import React from "react"

const DashboardIcon = <img src="/icons/painel.png" width={27} />
const DashboardIconActive = <img src="/icons/painel_hover.png" width={27} />
const XMLIcon = <img src="/icons/importar.svg" width={27} />
const XMLIconActive = <img src="/icons/importar_hover.svg" width={27} />
const CalcIcon = <img src="/icons/calculos.svg" width={27} />
const CalcIconActive = <img src="/icons/calculos_hover.svg" width={27} />
const EmpresaIcon = <img src="/icons/escritorio.png" width={27} />
const EmpresaIconActive = <img src="/icons/escritorio_hover.png" width={27} />
const HistorioIcon = <img src="/icons/historico_nfe.svg" width={27} />
const HistorioIconActive = <img src="/icons/historico_nfe_hover.svg" width={27} />
const ProductIcon = <img src="/icons/produtos.svg" width={27} />
const PackageIcon = <img src="/icons/produtos.svg" width={27} />
const MVAsIcon = <img src="/icons/mvas.svg" width={27} />
const TabelasIcon = <img src="/icons/historico_nfe.svg" width={27} />
const SefipIcon = <img src="/icons/historico_nfe.svg" width={27} />
const ClassificacaoIcon = <img src="/images/classificacao.png" width={27} />
const VariableIcon = <img src="/icons/variaveis.svg" width={27} />
const InvoiceIcon = <img src="/icons/formulas.svg" width={27} />
const UserIcon = <img src="/icons/contas.svg" width={27} />
const UtilsIcon = <img src="/images/settings.png" width={27} />

export interface INavItem {
  key: string;
  text: string;
  icon: any;
  iconActive: any;
  area: string;
  action?: string;
}

export const NAV_ITEMS: INavItem[] = [
  { key: "dashboard", text: "Dashboard", icon: DashboardIcon, iconActive: DashboardIconActive, area: "dashboard", },
];

export const NAV_LEGISLACAO_ARQUIVOS_PA: INavItem[] = [
  { key: "calculo-icms", text: "Cálculo Icms", icon: TabelasIcon, iconActive: TabelasIcon, area: "calculo-icms", },
  { key: "decreto-icms", text: "Decreto Icms", icon: TabelasIcon, iconActive: TabelasIcon, area: "decreto-icms", },
];

export const NAV_LEGISLACAO_TABELAS_PA: INavItem[] = [
  { key: "icms-aliquotas", text: "ALÍQUOTAS DE ICMS", icon: TabelasIcon, iconActive: TabelasIcon, area: "icms-aliquotas" },
  { key: "cnae", text: "CNAE", icon: TabelasIcon, iconActive: TabelasIcon, area: "cnae" },
  { key: "cst-cson", text: "CST - CSON/ICMS", icon: TabelasIcon, iconActive: TabelasIcon, area: "cst-cson" },
  { key: "pis-cofins", text: "CST - PIS/COFINS", icon: TabelasIcon, iconActive: TabelasIcon, area: "pis-cofins" },
  { key: "cst-origem", text: "CST - ORIGEM", icon: TabelasIcon, iconActive: TabelasIcon, area: "cst-origem" },
  { key: "eans", text: "EANS", icon: ProductIcon, iconActive: DashboardIconActive, area: "eans" },
  { key: "tipi", text: "TABELA TIPI", icon: TabelasIcon, iconActive: TabelasIcon, area: "tipi" },
  { key: "mvas-pa", text: "MVA'S", icon: MVAsIcon, iconActive: DashboardIconActive, area: "mvas-pa" },
  { key: "monofasico-simples", text: "MONOFÁSICO", icon: MVAsIcon, iconActive: DashboardIconActive, area: "monofasico-simples" },
  { key: "tributacao-nacional", text: "TRIBUTAÇÃO NACIONAL", icon: TabelasIcon, iconActive: TabelasIcon, area: "tributacao-nacional" },
  { key: "cfops", text: "CFOPS", icon: ProductIcon, iconActive: DashboardIconActive, area: "cfops" },
];

export const NAV_LEGISLACAO_RS: INavItem[] = [
  { key: "cnae", text: "CNAE", icon: TabelasIcon, iconActive: TabelasIcon, area: "cnae" },
  { key: "cst-cson", text: "CST - CSON/ICMS", icon: TabelasIcon, iconActive: TabelasIcon, area: "cst-cson" },
  { key: "pis-cofins", text: "CST - PIS/COFINS", icon: TabelasIcon, iconActive: TabelasIcon, area: "pis-cofins" },
  { key: "cst-origem", text: "CST - ORIGEM", icon: TabelasIcon, iconActive: TabelasIcon, area: "cst-origem" },
  { key: "eans", text: "EANS", icon: ProductIcon, iconActive: DashboardIconActive, area: "eans" },
  { key: "mvas-rs", text: "MVA'S", icon: MVAsIcon, iconActive: DashboardIconActive, area: "mvas-rs" },
  { key: "tributacao-nacional", text: "TRIBUTAÇÃO NACIONAL", icon: TabelasIcon, iconActive: TabelasIcon, area: "tributacao-nacional" },
  { key: "cfops", text: "CFOPS", icon: ProductIcon, iconActive: DashboardIconActive, area: "cfops" },
];

export const NAV_ITEMS4: INavItem[] = [
  { key: "pgdas", text: "PGDAS-D", icon: EmpresaIcon, iconActive: EmpresaIconActive, area: "pgdas", },
  { key: "sped", text: "SPED", icon: SefipIcon, iconActive: SefipIcon, area: "sped", },
  { key: "fgts-digital", text: "FGTS", icon: EmpresaIcon, iconActive: EmpresaIconActive, area: "fgts-digital", },
  { key: "dei", text: "DEI", icon: EmpresaIcon, iconActive: EmpresaIconActive, area: "dei", },
  //{ key: "parcelamentos", text: "Parcelamentos", icon: EmpresaIcon, iconActive: EmpresaIconActive, area: "parcelamentos", }
];

export const NAV_ITEMS4_SUB: INavItem[] = [
  { key: "conciliacao-bancaria", text: "Conciliação Bancária", icon: SefipIcon, iconActive: SefipIcon, area: "conciliacao-bancaria", },
  { key: "memoria-conciliacao", text: "Memória Conciliação", icon: SefipIcon, iconActive: SefipIcon, area: "memoria-conciliacao", },
];

export const CNPJS_ITEMS: INavItem[] = [
  { key: "empresas", text: "Empresas", icon: EmpresaIcon, iconActive: EmpresaIconActive, area: "empresas", },
];

export const XMLS_ITEMS: INavItem[] = [
  // { key: "downloads-xml", text: "Download de Xmls", icon: EmpresaIcon, iconActive: EmpresaIconActive, area: "downloads-xml", },
  { key: "imports", text: "Importação de Xmls", icon: XMLIcon, iconActive: XMLIconActive, area: "imports", },
  { key: "xml-integration", text: "XML Integração", icon: XMLIcon, iconActive: XMLIconActive, area: "xml-integration", },
  { key: "historico-notas", text: "Manifestações", icon: HistorioIcon, iconActive: HistorioIconActive, area: "historico-notas", },
  { key: "nfes", text: "NF-e, NFC-e, CT-e e NFS-e", icon: EmpresaIcon, iconActive: EmpresaIconActive, area: "nfes", },
  { key: "portal-nfe", text: "Portal da NF-e", icon: XMLIcon, iconActive: XMLIconActive, area: "portal-nfe", },
];

export const XMLS_ITEMS_SUB: INavItem[] = [
  // { key: "nfs-prefeitura", text: "NFS Prefeitura de Marabá", icon: EmpresaIcon, iconActive: EmpresaIconActive, area: "nfs-prefeitura", },
  { key: "solicitacoes-sefa", text: "Solicitações SEFA", icon: EmpresaIcon, iconActive: EmpresaIconActive, area: "solicitacoes-sefa", },
  { key: "nfse-prefeitura", text: "NFS-e Prefeitura", icon: EmpresaIcon, iconActive: EmpresaIconActive, area: "nfse-prefeitura", },
];

export const CALCULO_ITENS: INavItem[] = [
  { key: "memoria-calculo", text: "Memória de Cálculos", icon: CalcIcon, iconActive: CalcIconActive, area: "memoria-calculo", },
  { key: "resultados", text: "Resultados de Cálculos", icon: CalcIcon, iconActive: CalcIconActive, area: "resultados", },
];

export const NAV_RELATORIO: INavItem[] = [
  { key: "cnds", text: "CNDS", icon: EmpresaIcon, iconActive: EmpresaIconActive, area: "cnds", },
  { key: "relatorios", text: "Geral", icon: EmpresaIcon, iconActive: EmpresaIconActive, area: "relatorios", },
  // { key: "tarefas", text: "Gerenciamento de Tarefas", icon: UserIcon, iconActive: UserIcon, area: "tarefas", },
  { key: "sitfis", text: "Situação Fiscal (RFB)", icon: EmpresaIcon, iconActive: EmpresaIconActive, area: "sitfis", },
  { key: "sped-planilha", text: "SPED", icon: EmpresaIcon, iconActive: EmpresaIconActive, area: "sped-planilha", },
  { key: "relatorio_parcelamento", text: "Parcelamentos", icon: EmpresaIcon, iconActive: EmpresaIconActive, area: "relatorio_parcelamento", }
];

export const NAV_RELATORIO_CADASTROS: INavItem[] = [
  { key: "clientes", text: "Clientes", icon: EmpresaIcon, iconActive: EmpresaIconActive, area: "clientes", },
  { key: "fornecedores", text: "Fornecedores", icon: EmpresaIcon, iconActive: EmpresaIconActive, area: "fornecedores", },
];

export const NAV_RELATORIO_EMPRESAS: INavItem[] = [
  { key: "faixa-simples", text: "Faixa Simples Nacional", icon: EmpresaIcon, iconActive: EmpresaIconActive, area: "faixa-simples", },
  { key: "integracoes", text: "Integrações", icon: EmpresaIcon, iconActive: EmpresaIconActive, area: "integracoes", }
];

export const SEFIP: INavItem[] = [
  { key: "sefip-transmissao", text: "SEFIP TRANSMISSÃO", icon: SefipIcon, iconActive: SefipIcon, area: "sefip-transmissao", },
];

export const MANIFESTACOES: INavItem[] = [
  { key: "historico-notas", text: "Manifestações", icon: HistorioIcon, iconActive: HistorioIconActive, area: "historico-notas", },
  { key: "nfes", text: "NF-e, NFC-e, CT-e e NFS-e", icon: EmpresaIcon, iconActive: EmpresaIconActive, area: "nfes", },
];

export const IMPORTCOES_MANIFESTACOES_SEFIP: INavItem[] = [
  { key: "nfes", text: "NF-e, NFC-e, CT-e e NFS-e", icon: EmpresaIcon, iconActive: EmpresaIconActive, area: "nfes", },
  { key: "imports", text: "Importação de XMLs", icon: XMLIcon, iconActive: XMLIconActive, area: "imports", },
  { key: "resultados", text: "Cálculos", icon: CalcIcon, iconActive: CalcIconActive, area: "resultados", },
  { key: "historico-notas", text: "Manifestações", icon: HistorioIcon, iconActive: HistorioIconActive, area: "historico-notas", },
  // { key: "sefip-transmissao", text: "SEFIP TRANSMISSÃO", icon: SefipIcon, iconActive: SefipIcon, area: "sefip-transmissao", },
  { key: "classificacao", text: "Classificação", icon: ClassificacaoIcon, iconActive: ClassificacaoIcon, area: "classificacao", },
];

export const CLASSIFICACAO: INavItem[] = [
  { key: "classificacao", text: "Classificação", icon: ClassificacaoIcon, iconActive: ClassificacaoIcon, area: "classificacao", },
];


export const ADMIN_NAV_ITEMS: INavItem[] = [
  { key: "ajustes-sped", text: "Ajustes Sped", icon: UserIcon, iconActive: UserIcon, area: "ajustes-sped", },
  { key: "contas", text: "Contas", icon: UserIcon, iconActive: UserIcon, area: "contas", },
  { key: "empresas-admin", text: "Empresas", icon: UserIcon, iconActive: UserIcon, area: "empresas-admin", },
  { key: "legis-web-lucro", text: "Legis Web - Lucro", icon: TabelasIcon, iconActive: TabelasIcon, area: "legis-web-lucro", },
  { key: "legis-web-simples", text: "Legis Web - Simples", icon: TabelasIcon, iconActive: TabelasIcon, area: "legis-web-simples", },
  { key: "pauta-rs", text: "Pauta RS", icon: VariableIcon, iconActive: DashboardIconActive, area: "pauta-rs", },
  { key: "tabelas-sped", text: "Tabela Sped", icon: VariableIcon, iconActive: DashboardIconActive, area: "tabelas-sped", },
  { key: "tabela-simples", text: "Tabela Simples", icon: VariableIcon, iconActive: DashboardIconActive, area: "tabela-simples", },
  { key: "tabela-simples-excesso", text: "Tabela Simples Excesso", icon: VariableIcon, iconActive: DashboardIconActive, area: "tabela-simples-excesso", },
];

export const VARS_ITEMS_SUB: INavItem[] = [
  { key: "vars", text: "PA", icon: VariableIcon, iconActive: DashboardIconActive, area: "vars", },
  { key: "vars-fcp", text: "FCP", icon: VariableIcon, iconActive: DashboardIconActive, area: "vars-fcp", },
  { key: "vars-calc", text: "CÁLCULO", icon: VariableIcon, iconActive: DashboardIconActive, area: "vars-calc", },
];

export const CALCULO_ITEMS_SUB: INavItem[] = [
  { key: "calcs", text: "PA", icon: InvoiceIcon, iconActive: DashboardIconActive, area: "calcs", },
  { key: "calcs-rs", text: "RS", icon: InvoiceIcon, iconActive: DashboardIconActive, area: "calcs-rs", },
];

export const UTILS_ITENS: INavItem[] = [
  { key: "equaliza-ncm", text: "Equalização de NCMs", icon: UtilsIcon, iconActive: UtilsIcon, area: "equaliza-ncm", },
];

export const PRODUTOS_ITEMS_SUB: INavItem[] = [
  { key: "produtos", text: "PA", icon: PackageIcon, iconActive: DashboardIconActive, area: "produtos" },
  { key: "produtos-rs", text: "RS", icon: PackageIcon, iconActive: DashboardIconActive, area: "produtos-rs" }
];
